import { Link, useLocation } from "react-router-dom";
import { Palette, Search, Settings, LayoutDashboard, Briefcase, Heart } from "lucide-react";
import { cn } from "@/lib/utils";
import { SparklesCore } from "@/components/ui/sparkles";
import { useTranslation } from "react-i18next";

export function MobileNavigation() {
  const location = useLocation();
  const { t } = useTranslation();
  
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background border-t md:hidden z-50">
      <nav className="flex justify-around items-center h-14 px-4">
        <Link 
          to="/feed" 
          className={cn(
            "flex items-center button-pop",
            isActive("/feed") ? "text-primary" : "text-muted-foreground"
          )}
          aria-label={t('nav.feed')}
        >
          <Palette className="h-6 w-6" />
        </Link>
        
        <Link 
          to="/opportunities" 
          className={cn(
            "flex items-center button-pop relative",
            isActive("/opportunities") ? "text-primary" : "text-muted-foreground"
          )}
          aria-label={t('nav.opportunities')}
        >
          <div className="relative">
            <Briefcase className="h-6 w-6 relative z-10" />
            <div className="absolute -inset-2 pointer-events-none">
              <SparklesCore 
                className="w-full h-full"
                particleColor="#FF6B6B"
                number={{ 
                  density: {
                    enable: true,
                    width: 150,
                    height: 150
                  },
                  value: 60
                }}
                speed={1}
                minSize={0.6}
                maxSize={1.4}
                background="transparent"
              />
            </div>
          </div>
        </Link>
        
        <Link 
          to="/directory" 
          className={cn(
            "flex items-center button-pop",
            isActive("/directory") ? "text-primary" : "text-muted-foreground"
          )}
          aria-label={t('nav.directory')}
        >
          <Search className="h-6 w-6" />
        </Link>
        
        <Link 
          to="/mailbox" 
          className={cn(
            "flex items-center button-pop",
            isActive("/mailbox") ? "text-primary" : "text-muted-foreground"
          )}
          aria-label={t('nav.mailbox')}
        >
          <Heart className="h-6 w-6" />
        </Link>
        
        <Link 
          to="/profile" 
          className={cn(
            "flex items-center button-pop",
            isActive("/profile") ? "text-primary" : "text-muted-foreground"
          )}
          aria-label={t('nav.portfolio')}
        >
          <LayoutDashboard className="h-6 w-6" />
        </Link>
      </nav>
    </div>
  );
}